// v3.4.342 — Chairman Office › التواصل الخارجي: قناتا واتساب «ابوبدر 2» و«ابوبدر بزنس» (نُقلتا من «تواصل واتس مباشر» وحُصرتا في مكتب رئيس المجلس)
import React, { useState } from "react";
import CommunicationPage from "./CommunicationPage";

const CHANNELS = [
  { key: "abubader2", label: "💬 تواصل ابوبدر 2" },
  { key: "abubader_biz", label: "💼 تواصل ابوبدر بزنس" },
];

export default function ChairmanCommPage() {
  const [tab, setTab] = useState(() => { try { return localStorage.getItem("cm_comm_tab") || "abubader2"; } catch { return "abubader2"; } });
  const pick = (k) => { setTab(k); try { localStorage.setItem("cm_comm_tab", k); } catch {} };
  return (
    <div dir="rtl" style={{ display: "flex", flexDirection: "column", minHeight: 0 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 16px 0", flexWrap: "wrap" }}>
        <div><h2 style={{ margin: 0, fontSize: 18 }}>📲 التواصل الخارجي</h2><div style={{ fontSize: 11.5, color: "#94a3b8" }}>واتساب رئيس مجلس الإدارة — محادثات شخصية (قراءة ورد وإرسال) بلا أدوات التسويق</div></div>
        <div style={{ display: "flex", gap: 2, marginInlineStart: 16, borderBottom: "1px solid #e2e8f0" }}>
          {CHANNELS.map(c => <button key={c.key} onClick={() => pick(c.key)} style={{ padding: "8px 16px", border: "none", borderBottom: "3px solid " + (tab === c.key ? "#0f766e" : "transparent"), background: "transparent", color: tab === c.key ? "#0f766e" : "#64748b", fontWeight: 800, fontSize: 13, cursor: "pointer", fontFamily: "inherit" }}>{c.label}</button>)}
        </div>
      </div>
      <CommunicationPage key={"chairman-" + tab} defaultTab={tab} personal />{/* v3.4.343 — محادثات فقط */}
    </div>
  );
}
